import { Form } from "@inertiajs/react";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/ui/button";
import {
  Field,
  FieldError,
  FieldGroup,
  FieldLabel,
} from "@/components/ui/field";
import { PasswordInput } from "@/components/forms/password-input";
import { FormErrors, errorText } from "@/components/forms/form-errors";
import { Spinner } from "@/components/ui/spinner";
import { userPasswordPath } from "@/routes";

export function PasswordForm() {
  const { t } = useTranslation();
  return (
    <Form action={userPasswordPath()} method="patch" resetOnSuccess>
      {({ errors, processing }) => (
        <FieldGroup>
          <FormErrors
            errors={errors}
            targets={{
              current_password: "current_password",
              password: "new_password",
              password_confirmation: "password_confirmation",
            }}
          />
          <Field>
            <FieldLabel htmlFor="current_password">
              {t("fields.current_password")}
            </FieldLabel>
            <PasswordInput
              id="current_password"
              name="user[current_password]"
              autoComplete="current-password"
              required
            />
            <FieldError>{errorText(errors.current_password)}</FieldError>
          </Field>
          <Field>
            <FieldLabel htmlFor="new_password">{t("auth.password")}</FieldLabel>
            <PasswordInput
              id="new_password"
              name="user[password]"
              autoComplete="new-password"
              required
            />
            <FieldError>{errorText(errors.password)}</FieldError>
          </Field>
          <Field>
            <FieldLabel htmlFor="password_confirmation">
              {t("auth.password_confirmation")}
            </FieldLabel>
            <PasswordInput
              id="password_confirmation"
              name="user[password_confirmation]"
              autoComplete="new-password"
              required
            />
            <FieldError>{errorText(errors.password_confirmation)}</FieldError>
          </Field>
          <Button type="submit" className="w-fit" disabled={processing}>
            {processing && <Spinner />}
            {t("common.save")}
          </Button>
        </FieldGroup>
      )}
    </Form>
  );
}
